module.exports = __webpack_public_path__ + "img/SFG_Header_Graphics_2_Desktop.612da466.png";